import { render, staticRenderFns } from "./InsolvRegistry.vue?vue&type=template&id=466f3550&scoped=true&"
import script from "./InsolvRegistry.vue?vue&type=script&lang=js&"
export * from "./InsolvRegistry.vue?vue&type=script&lang=js&"
import style0 from "./InsolvRegistry.vue?vue&type=style&index=0&id=466f3550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466f3550",
  null
  
)

export default component.exports